import type {
  Currency,
  ExperienceFilters,
  ExperienceSelection,
  VehicleFilters,
  VehicleKind,
  VehicleSearch,
} from '../domain';

/** Query keys in one place, so mutations can invalidate precisely. */
export const qk = {
  config: ['config'] as const,
  session: ['session'] as const,
  cities: (kind: VehicleKind) => ['cities', kind] as const,
  experienceCities: ['cities', 'experiences'] as const,
  destinations: ['destinations'] as const,
  vehicleSearch: (s: VehicleSearch, f: VehicleFilters) => ['vehicles', 'search', s, f] as const,
  categories: (kind: VehicleKind, city: string) => ['vehicles', 'categories', kind, city] as const,
  featured: (city: string) => ['vehicles', 'featured', city] as const,
  vehicle: (id: string) => ['vehicles', id] as const,
  similar: (id: string) => ['vehicles', id, 'similar'] as const,
  quote: (id: string, s: VehicleSearch, currency: Currency = 'MAD') => ['vehicles', id, 'quote', s, currency] as const,
  availability: (id: string, start: string, end: string, pickupTime?: string, returnTime?: string) =>
    ['vehicles', id, 'availability', start, end, pickupTime ?? '', returnTime ?? ''] as const,
  refund: (start: string, time: string) => ['refund', start, time] as const,
  experiences: (f: ExperienceFilters) => ['experiences', f] as const,
  experienceCategories: (city: string) => ['experiences', 'categories', city] as const,
  experience: (id: string) => ['experiences', 'one', id] as const,
  experienceDays: (id: string, from: string) => ['experiences', 'one', id, 'days', from] as const,
  experienceQuote: (s: ExperienceSelection) => ['experiences', 'quote', s] as const,
  booking: (id: string) => ['bookings', id] as const,
  agency: (slug: string) => ['agencies', slug] as const,
  blog: ['blog'] as const,
  blogPost: (id: string) => ['blog', id] as const,
  trips: ['trips'] as const,
  carts: ['carts'] as const,
  favourites: ['favourites'] as const,
  favouriteIds: ['favourites', 'ids'] as const,
  stats: ['profile', 'stats'] as const,
  threads: ['threads'] as const,
  paymentConfig: ['payments', 'config'] as const,
  /* P5, P13, P15 */
  cancelPreview: (id: string) => ['trips', id, 'cancel-preview'] as const,
  tripToRate: ['trips', 'to-rate'] as const,
  reviews: ['reviews'] as const,
  partnerStatus: ['account', 'partner-status'] as const,
  resultsPages: (s: VehicleSearch, f: VehicleFilters) => ['vehicles', 'results', s, f] as const,
  activityCategory: (id: string) => ['experiences', 'category-id', id] as const,
  /* P6 */
  experienceSlots: (id: string, from: string, to: string) => ['experiences', 'one', id, 'slots', from, to] as const,
  eligibility: (id: string) => ['experiences', 'eligibility', id] as const,
  /* Cross-sell (API-ACT-16) */
  crossSellExperiences: (city: string, from: string, to: string, limit: number) =>
    ['experiences', 'cross-sell', city, from, to, limit] as const,
};
